import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  ModalBody,
  Input,
  Label,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Button,
  Row,
  Col,
} from "reactstrap";

import { Link } from "react-router-dom";

import sendQuote from "../../assets/images/sendquote.jpg";

const RightSideContent2 = ({
  Items,
  handlePayNowClick,
  address,
  paymentDetails,
  toggleModal,
  togglePaymentModal,
  handleEditAddress,
  handleEditPayment,
  calculateTotal,
  firstName,
  lastName,
  email,
  contactNumber,
  handlePersonalDetailsChange,
  reservationIds,
  billingInfo,
}) => {
  const buyerDetails = {
    address: address,
    firstName: firstName,
    lastName: lastName,
    email: email,
    contactNumber: contactNumber,
  };
  const total_Courier_price = Items.reduce((acc, item) => {
    console.log("items c", item);
    const Courier_Fee = item.Courier_Fee ?? item.courier_Fee;

    return acc + Courier_Fee;
  }, 0);

  console.log(Items);

  const total_Processing_price = Items.reduce((acc, item) => {
    const Processing_Fee = item.Processing_Fee * item.quantity;

    return acc + Processing_Fee;
  }, 0);

  console.log(Items);

  const total_fish_price = Items.reduce((acc, item) => {
    const pricePerKg = item.stockData.Price_per_Kg;
    const quantity = item.quantity;
    return acc + pricePerKg * quantity;
  }, 0);

  //Apply Now Model
  const [modal, setModal] = useState(false);
  const openModal = () => setModal(!modal);
  const [isPaying, setIsPaying] = useState(false);
  const [reservationId, setReservationId] = useState("");
  const popupRef = useRef(null);
  const timerRef = useRef(null);
  const [clickResponse, setClickResponse] = useState(null);
  const [formData, setFormData] = useState({
    quotationNumber: "",
    quotationDate: "",
    expiryDate: "",
    buyerName: "",
    companyName: "",
    buyerEmail: "",
    buyerPhone: "",
    vesselOwnerName: "",
    boatName: "",
    ownerEmail: "",
    ownerPhone: "",
    fishSpecies: "",
    quantity: "",
    size: "",
    processing: "",
    packaging: "",
    qualityGrade: "",
    unitPrice: "",
    shippingFee: "",
    vat: "",
    totalPrice: "",
    deliveryAddress: "",
    deliveryMethod: "",
    deliveryDate: "",
    paymentMethod: "",
    paymentDue: "",
  });

  const [params, setParams] = useState(null);

  const startPayment = async () => {
    // Validate billing information
    if (
      !billingInfo.bill_to_forename ||
      !billingInfo.bill_to_surname ||
      !billingInfo.bill_to_email ||
      !billingInfo.bill_to_phone ||
      !billingInfo.bill_to_address_line1 ||
      !billingInfo.bill_to_address_city ||
      !billingInfo.bill_to_address_country ||
      !billingInfo.bill_to_address_postal_code
    ) {
      alert("Please fill in all required billing information fields.");
      return;
    }

    // 1️⃣ Call handlePayNowClick to get the backend response
    const response = await handlePayNowClick();
    if (!response?.data?.data) {
      console.error("Invalid response from handlePayNowClick");
      return;
    } else {
      setClickResponse(response);
    }
  };
  useEffect(() => {
    // If reservationIds is set, trigger the payment flow
    const proceedWithPayment = async () => {
      if (reservationIds.length > 0 && clickResponse) {
        console.log("Child received updated reservationIds:", reservationIds);

        // 2️⃣ Extract order IDs from response
        const orderIds = clickResponse.data.data.map((item) => item.Order_id);
        console.log("Order IDs:", orderIds);
        // 3️⃣ Proceed with payment

        if (clickResponse) {
          try {
            const res = await fetch(
              "https://api.starmarketapi.online/stock_details/api/payment/request",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  amount:
                    total_fish_price +
                    total_Processing_price +
                    total_Courier_price,
                  currency: "LKR",
                  referenceNumber: "order123",
                  merchant_defined_data1: reservationIds, // ✅ now available
                  merchant_defined_data2: orderIds,
                  // Billing information for CyberSource
                  ...billingInfo,
                }),
              },
            );

            const data = await res.json();

            setParams(data);

            // 4️⃣ Wait for React to render the updated form, then submit
            setTimeout(() => {
              const form = document.getElementById("cybersource-form");
              if (form) {
                form.submit();
              } else {
                console.error("Form not found in DOM.");
              }
            }, 100);
          } catch (err) {
            console.error("Payment initiation failed:", err);
            alert("Failed to start payment. Please try again.");
          }
        }
      }
    };

    proceedWithPayment();
  }, [reservationIds, clickResponse]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    // Add form submission logic here
  };

  return (
    <React.Fragment>
      <div className="side-bar ms-lg-4">
        <Card className="job-overview">
          <CardBody className="p-4">
            <h6 className="fs-17">Order Overview</h6>

            <div className="mt-3">
              <Card
                className="border-primary"
                style={{ background: "#ecf6ff", border: "none" }}
              >
                <CardBody>
                  <Row>
                    <Col>
                      <span>Fish Price:</span>
                    </Col>
                    <Col className="text-end">{total_fish_price} LKR</Col>
                  </Row>
                  <Row>
                    <Col>
                      <span>Processing:</span>
                    </Col>
                    <Col className="text-end">{total_Processing_price} LKR</Col>
                  </Row>
                  <Row>
                    <Col>
                      <span>Courier:</span>
                    </Col>
                    <Col className="text-end">{total_Courier_price} LKR</Col>
                  </Row>
                  <hr />
                  <Row style={{ fontSize: "17px" }}>
                    <Col>
                      <strong>Total:</strong>
                    </Col>
                    <Col className="text-end">
                      <strong>
                        {total_Courier_price +
                          total_Processing_price +
                          total_fish_price}{" "}
                        LKR
                      </strong>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <>
                <button
                  onClick={startPayment}
                  disabled={isPaying}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md disabled:bg-gray-400 btn btn-black1 mt-3"
                >
                  {isPaying ? "Processing..." : "Pay Now"}
                </button>

                {params && (
                  <form
                    id="cybersource-form"
                    method="post"
                    action="https://testsecureacceptance.cybersource.com/pay"
                  >
                    {Object.entries(params).map(([key, value]) => (
                      <input key={key} type="hidden" name={key} value={value} />
                    ))}
                  </form>
                )}
              </>
            </div>
          </CardBody>
        </Card>

        <div
          className="modal fade"
          id="applyNow"
          tabIndex="-1"
          aria-labelledby="applyNow"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <Modal isOpen={modal} toggle={openModal} centered>
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Pay Now
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={openModal}
                ></button>
              </div>

              <ModalBody className="modal-body p-5">
                <Form onSubmit={handleSubmit}>
                  <Row>
                    {/* Quotation Details */}
                    <Col md={12}>
                      <img src={sendQuote} style={{ width: "100%" }} />
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="quotationNumber">
                          Purchase Order Number:{" "}
                        </Label>
                        <Label>000002</Label>
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="companyName">Company Name: </Label>
                        <Label for="companyName">Fish Ltd.</Label>
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="quotationDate">Purchase Order Date</Label>
                        <Input
                          type="date"
                          name="quotationDate"
                          id="quotationDate"
                          value={formData.quotationDate}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="expiryDate">Expiry Date</Label>
                        <Input
                          type="date"
                          name="expiryDate"
                          id="expiryDate"
                          value={formData.expiryDate}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>

                    {/* Buyer Information */}

                    {/* Vessel Owner Information */}

                    {/* Stock Details */}
                    <Col md={12}>
                      <FormGroup>
                        <Label for="fishSpecies">Fish Species</Label>
                        <Input
                          type="text"
                          name="fishSpecies"
                          id="fishSpecies"
                          value={formData.fishSpecies}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="quantity">Quantity (kg)</Label>
                        <Input
                          type="number"
                          name="quantity"
                          id="quantity"
                          value={formData.quantity}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={12}>
                      <FormGroup>
                        <Label for="processing">Processing Type</Label>
                        <Input
                          type="text"
                          name="processing"
                          id="processing"
                          value={formData.processing}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="packaging">Packaging Type</Label>
                        <Input
                          type="text"
                          name="packaging"
                          id="packaging"
                          value={formData.packaging}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>

                    {/* Pricing and Delivery */}
                    <Col md={12}>
                      <FormGroup>
                        <Label for="unitPrice">Unit Price ($)</Label>
                        <Input
                          type="number"
                          name="unitPrice"
                          id="unitPrice"
                          value={formData.unitPrice}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="shippingFee">Shipping Fee ($)</Label>
                        <Input
                          type="number"
                          name="shippingFee"
                          id="shippingFee"
                          value={formData.shippingFee}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="vat">VAT (%)</Label>
                        <Input
                          type="number"
                          name="vat"
                          id="vat"
                          value={formData.vat}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="deliveryAddress">Delivery Address</Label>
                        <Input
                          type="text"
                          name="deliveryAddress"
                          id="deliveryAddress"
                          value={formData.deliveryAddress}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="deliveryMethod">Delivery Method</Label>
                        <Input
                          type="text"
                          name="deliveryMethod"
                          id="deliveryMethod"
                          value={formData.deliveryMethod}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="deliveryDate">Expected Delivery Date</Label>
                        <Input
                          type="date"
                          name="deliveryDate"
                          id="deliveryDate"
                          value={formData.deliveryDate}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>

                    {/* Payment Details */}
                    <Col md={12}>
                      <FormGroup>
                        <Label for="paymentMethod">Payment Method</Label>
                        <Input
                          type="text"
                          name="paymentMethod"
                          id="paymentMethod"
                          value={formData.paymentMethod}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="paymentDue">Payment Due Date</Label>
                        <Input
                          type="date"
                          name="paymentDue"
                          id="paymentDue"
                          value={formData.paymentDue}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button color="btn btn-black1" type="submit">
                    Pay Now
                  </Button>
                </Form>
              </ModalBody>
            </Modal>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RightSideContent2;
